import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { ToastService } from 'src/app/core/services/toast.service';
import { FormBuilder,AbstractControl,Validators, FormGroup } from '@angular/forms';
import { NewsletterService } from 'src/app/core/services/newsletter.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  subscriptionForm: FormGroup;
  @ViewChild('subscriptionFormRef') subscriptionFormRef!: ElementRef<HTMLFormElement>;
  emailRegex = new RegExp(
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  );
  constructor(private toast : ToastService,private _fb: FormBuilder, private newsletterService:NewsletterService) { }

  object = {
    email:null
  }
  ngOnInit(): void {

    this.subscriptionForm = this._fb.group({

      email: [null, [Validators.required, Validators.pattern(this.emailRegex)]],
    });
  }

  async addNewsLetterSubscription(){
    if(this.subscriptionForm.invalid){
      this.toast.openSnackBar('Please enter valid email address');
      return;
    }
    //this.spinner.show();
    try {
      this.object.email = this.subscriptionForm.value.email
     const result = await this.newsletterService.addNewsLetterSubscription(this.object).toPromise();
     
     // this.spinner.hide();
      this.toast.openSnackBar("You are subscribed to weekly newsletter successfully");
      this.subscriptionFormRef.nativeElement.reset();
    } catch(error){
     // this.spinner.hide();
      //this.toast.openSnackBar("You are not subscribed to weekly newsletter. try again");
    }
  }

  }


